import gql from "graphql-tag";

export const subscriptionFragment = gql`
  fragment SubscriptionFragment on Subscription {
    id
    email
    active
    created
    unsubscribed
    subscriptionId
  }
`;
